/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { NgClass } from "@angular/common";
import { Component, EventEmitter, Input, Output, OnInit } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { SelectOption } from "../../models/ui/select-option.model";

@Component({
	selector: "globalictcc-switch",
	standalone: true,
	imports: [MatButtonModule, NgClass],
	templateUrl: "./switch.component.html",
	styleUrl: "./switch.component.scss"
})
export class SwitchComponent implements OnInit {
	@Input() public options: SelectOption[] = [];

	@Output() public handleSwitch = new EventEmitter<string>();

	public selectedBtn: string;

	ngOnInit() {
		this.selectedBtn =
			this.options.length > 0
				? (this.options.find(o => o.selected)?.value ?? this.options[0].value)
				: "";
	}
}
